import React from "react";
import { useState, useEffect, useRef } from "react";
import LoadingBar from "react-top-loading-bar";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MergePDFMergerListScreen from "./MergePDFMergerListScreen";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";

function MergePDFMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Merge PDF files" };
  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/merge_pdf", title: "PDF Merger" },
    data2: { link: "/merge_pdf", title: "Combine multiple PDFs" },
    data3: { link: "/merge_pdf", title: "Join PDFs" },
  };

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Merge PDF files online easily. Combine multiple PDFs into one document quickly using our fast, secure, and user-friendly PDF merger tool."
      ></meta>
      <meta
        name="keywords"
        content="pdf merger, merge pdf, combine pdf files, merge pdf online, pdf combiner, join pdf files, online pdf merger, merge multiple pdfs, pdf merge tool, combine pdf online, pdf editor online, pdf management tool, merge pdf free, pdf file merger, join pdf documents"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <MergePDFMergerListScreen title={title}></MergePDFMergerListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={true}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Offline Merge PDF Tool is a powerful and secure solution designed for users who want to merge PDF files offline without relying on an internet connection, making it ideal for professionals, businesses, and individuals who need complete privacy and control over their documents. This advanced PDF merger software allows you to combine multiple PDF files into one document, arrange pages in the desired order, and seamlessly merge large PDF files while preserving original formatting, layout, fonts, and image quality. Unlike online tools, this offline PDF merge tool processes all files directly on your device, ensuring sensitive data remains private and protected, which is essential for handling legal documents, financial reports, contracts, and confidential files. With fast performance and intelligent processing, the tool supports batch merging, unlimited file sizes, and smooth operation on Windows, macOS, and other desktop platforms. Whether you need to merge PDFs for work, create a single file from multiple reports, or organize scanned documents efficiently, this best offline PDF merger provides a user-friendly interface, high-speed processing, and reliable results, making it the perfect secure PDF merge solution for offline PDF management." />
          {/* How to use define max 4 steps */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Merge",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="PDF Merger"
            why_use={[
              {
                title: "Combine Multiple PDF Files Easily",
                description:
                  "Merge several PDF documents into one organized file, making it easier to store, view, and manage.",
              },
              {
                title: "Simplify Document Sharing",
                description:
                  "Share a single merged PDF instead of sending multiple attachments, reducing confusion and improving convenience.",
              },
              {
                title: "Privacy & Protect",
                description:
                  "You documents are protected through our high level encryption and deleted immediately after compression.",
              },

              {
                title: "Improve Workflow Efficiency",
                description:
                  "A fast and easy-to-use PDF merger tool helps students and professionals work more efficiently by keeping everything in one place.",
              },
              {
                title: "Stay Organized and Reduce Clutter",
                description:
                  "Merge invoices, reports, receipts, and scanned pages to keep your digital workspace clean and structured.",
              },
              {
                title: "Quick & Easy",
                description:
                  "Save your time as this app is quick and easy to use, just select file and convert it.",
              },
              {
                title: "Free to use",
                description:
                  "You don't need any account or sign up to start using our service. Very little time required to get your jobs done and the great part is it is free to use. And our app works completely offline.",
              },
              {
                title: "Bulk Conversion",
                description:
                  "Combine multiple pdf files at once and save time using the premium version of this app.",
              },
              {
                title: "Save Storage Space",
                description:
                  "Use a PDF merge and compress tool to optimize file size while keeping everything neatly consolidated.",
              },
            ]}
          />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1624184310}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default MergePDFMain;
